import request from '@/utils/request'

const basePath = "/api/enterprise";

export const batchUploadPath = `${basePath}/batch/import`;

/**
 * 查询企业基础信息
 * @param id
 */
export function getInfoById(id) {
    return request({
        url: `/api/enterprise/${id}`,
        method: 'get'
    })
}

/**
 * 根据当前用户企业id查询企业信息
 */
export function getInfo() {
    return request({
        url: `/api/enterprise`,
        method: 'get'
    })
}

/**
 * 查询企业详情
 * @param id
 */
export function getInfoExtByEnterpriseId(id) {
    return request({
        url: '/api/enterprise/detail/' + id,
        method: 'get'
    });
}

/**
 * 根据当前用户企业id查询企业详细信息
 */
export function getInfoExt(){
    return request({
        url: '/api/enterprise/detail',
        method: 'get'
    })
}

/**
 * 保存企业详情
 * @param extInfo
 * @param logoFileId
 * @param photoFileIds
 */
export function saveInfoExt(extInfo,logoFileId, photoFileIds) {
    return request({
        url: `/api/enterprise/detail?logoFileId=${logoFileId}&photoFileIds=${photoFileIds}`,
        method: 'post',
        data: extInfo
    });
}

/**
 * 修改企业详情
 * @param params
 */
export function updateInfoExt(extInfo, logoFileId, photoFileIds) {
    return request({
        url: `/api/enterprise/detail?logoFileId=${logoFileId}&photoFileIds=${photoFileIds}`,
        method: 'put',
        data: extInfo
    });
}

/**
 * 合并文件分块
 * @param params
 */
export function mergeFile(params) {
    return request({
        url: 'api/file/merge',
        method: 'post',
        data: params
    })
}

/**
 * 企业认证
 */
export function authentication(form,licensePhotoFileId) {
    return request({
        url:`/api/enterprise?licensePhotoFileId=${licensePhotoFileId}`,
        method: 'post',
        data: form,
    })
}

/**
 * 分页查询企业信息
 */
export function getEnterpriseByPage(params) {
    return request({
        url:`/api/enterprise/search`,
        method: 'get',
        params: params
    })
}

/**
 * 封禁企业
 */
export function banEnterprise(id) {
    return request({
        url:`/api/enterprise/ban/${id}`,
        method: 'get',
    })
}

/**
 * 解禁企业
 */
export function unbanEnterprise(id) {
    return request({
        url:`/api/enterprise/unban/${id}`,
        method: 'get',
    })
}

/**
 * 获取登录用户详细信息
 */
export function checkUserAndEnt() {
    return request({
        url: `/api/enterprise/checkUserAndEnt`,
        method: 'get'
    });
}

/**
 * 获取热门企业
 */
export function getHotEnterpriseInfo() {
    return request({
        url: `/api/enterprise/public/hot`,
        method: 'get'
    });
}

/**
 * 获取企业下拉框数据
 */
export function getEnterpriseList() {
    return request({
        url: `${basePath}/list`,
        method: 'get'
    });
}

// 分页查询企业
export function getCompantPageByEs(params) {
    return request({
        url: `${basePath}/public/page`,
        method: 'get',
        params: params
    })
}

// 查询企业所在城市
export function findPublicCityTop(params) {
    return request({
        url: `${basePath}/public/city/top`,
        method: 'get',
        params: params
    });
}

/**
 * 保存企业信息
 * @param data
 */
export function saveEnterprise(data) {
    return request({
        url: `/api/enterprise/admin`,
        method: 'post',
        data: data
    });
}

/**
 * 保存企业信息
 * @param data
 */
export function updateEnterprise(enterpriseId, data) {
    return request({
        url: `/api/enterprise/admin/${enterpriseId}`,
        method: 'put',
        data: data
    });
}